import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
var _excluded = ["dispatch", "csrf", "id", "className", "role", "onSubmit", "children", "noValidate"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form() {
    _classCallCheck(this, Form);
    return _super.apply(this, arguments);
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dispatch = _this$props.dispatch,
        csrf = _this$props.csrf,
        id = _this$props.id,
        className = _this$props.className,
        role = _this$props.role,
        onSubmit = _this$props.onSubmit,
        children = _this$props.children,
        noValidate = _this$props.noValidate,
        extraProps = _objectWithoutProperties(_this$props, _excluded);
      return (
        /*#__PURE__*/
        // $FlowFixMe[cannot-spread-inexact]
        React.createElement("form", _extends({
          id: id,
          className: className,
          role: role,
          onSubmit: onSubmit,
          noValidate: noValidate
        }, extraProps), csrf && csrf.enabled && /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "_csrf_token",
          value: csrf.token
        }), children)
      );
    }
  }]);
  return Form;
}(React.Component);
Form.propTypes = {
  csrf: PropTypes.object,
  id: PropTypes.string,
  className: PropTypes.string,
  role: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func,
  noValidate: PropTypes.bool
};
Form.defaultProps = {
  className: '',
  role: 'form',
  noValidate: true
};
var FormConnected = connect(function (state) {
  return {
    csrf: state.csrf
  };
})(Form);
export default FormConnected;